/**
 * Inverts the boolean value of `x`.
 *
 * @param {*} x
 * @returns {boolean}
 */
export function not(x) {
  return !x;
}
